import { useTranslation } from 'react-i18next';

const CustomizeRequiredMark = (label: React.ReactNode, { required }: { required: boolean }) => {
  const { t } = useTranslation('common');
  return (
    <>
      {required && (
        <span
          style={{
            color: '#e0407a',
            marginInlineEnd: '4px',
            lineHeight: 1,
          }}
        >
          *
        </span>
      )}
      {label}
      {!required && (
        <span
          className="ant-form-item-optional"
          style={{
            fontWeight: 400,
          }}
        >
          {`(${t('optional')})`}
        </span>
      )}
    </>
  );
};
export default CustomizeRequiredMark;
